module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Chapter One:")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE1#_idTextAnchor003"
    }
  }, [_vm._v("Earth-Based Souls and Interplanetary Souls: The Differences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Two:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE2#_idTextAnchor004"
    }
  }, [_vm._v("Life Purpose of Interplanetary Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Three:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE3#_idTextAnchor005"
    }
  }, [_vm._v("Earth Incarnation Challenges for Interplanetary Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Four:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE4#_idTextAnchor006"
    }
  }, [_vm._v("Mislabeling and Misunderstanding Interplanetary Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Five:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE5#_idTextAnchor007"
    }
  }, [_vm._v("Spirit Guides, Senior Elders, and the Interplanetary Council")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Six:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE6#_idTextAnchor008"
    }
  }, [_vm._v("Soul Archetypes and Past Lives of Interplanetary Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Seven:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE7#_idTextAnchor010"
    }
  }, [_vm._v("Interplanetary Soul Family Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Eight:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE8#_idTextAnchor011"
    }
  }, [_vm._v("Parenting an Interplanetary Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Nine:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE9#_idTextAnchor012"
    }
  }, [_vm._v("Survival Guide for Interplanetary Souls on Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter Ten:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE10#_idTextAnchor013"
    }
  }, [_vm._v("Essential Action to Evolve Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE11#_idTextAnchor015"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Appendix: Training in Soul Regression Therapy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/SOE12#_idTextAnchor016"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Glossary")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0